import React from 'react';
import { useReveal } from '../lib/useReveal';
const COST_DATA = [{
  sin: 'Años con cansancio que el descanso no cura',
  costo: 'Tiempo y vitalidad que no vuelven'
}, {
  sin: 'Ansiedad sin herramientas de regulación',
  costo: 'Calidad de vida que se erosiona día a día'
}, {
  sin: 'Prácticas sueltas que no conectan entre sí',
  costo: 'Dinero y energía gastados sin sistema ni resultado'
}, {
  sin: 'Sin protocolo de bienestar claro',
  costo: 'Improvisación que genera más agotamiento'
}, {
  sin: 'Presión familiar y social sin herramientas',
  costo: 'Desgaste emocional acumulado que pesa más cada mes'
}, {
  sin: 'El vínculo de pareja bajo tensión sin comunicación',
  costo: 'Distancia que crece sin poder nombrarse'
}, {
  sin: 'El mismo ciclo de postergación',
  costo: 'El próximo año exactamente igual que este'
}];
export function CostSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-brand-primary py-8 md:py-10 px-4 sm:px-6 border-t border-brand-border-soft" data-id="element-85">
      <div className="container mx-auto max-w-4xl" data-id="element-86">
        <div ref={ref} className={`reveal ${vis ? 'is-visible' : ''}`} data-id="element-87">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-6 md:mb-8 text-center text-brand-heading tracking-wide" data-id="element-88">
            ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
          </h2>

          <div className="overflow-x-auto pb-4 mb-6" data-id="element-89">
            <table className="w-full min-w-[600px] border-collapse bg-white rounded-xl overflow-hidden border border-brand-border-soft shadow-sm" data-id="element-90">
              <thead data-id="element-91">
                <tr data-id="element-92">
                  <th className="text-left p-5 border-b border-brand-border-soft text-brand-subheading font-bold w-1/2 bg-brand-alternate" data-id="element-93">
                    Sin MegaPack
                  </th>
                  <th className="text-left p-5 border-b border-brand-border-soft text-brand-cta font-bold w-1/2 bg-[#FCE4EC]" data-id="element-94">
                    Costo real
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-95">
                {COST_DATA.map((row, i) => <tr key={i} className="border-b border-brand-border-soft hover:bg-brand-primary/30 transition-colors" data-id="element-96">
                    <td className="p-5 text-brand-body text-sm md:text-base font-medium" data-id="element-97">
                      {row.sin}
                    </td>
                    <td className="p-5 text-brand-subheading font-medium text-sm md:text-base bg-[#FCE4EC]/30" data-id="element-98">
                      {row.costo}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          <div className="text-center space-y-4" data-id="element-99">
            <p className="text-xl md:text-2xl text-brand-heading font-medium" data-id="element-100">
              El próximo paso en tu camino puede empezar hoy.
            </p>
            <p className="text-2xl md:text-3xl font-display font-bold text-brand-cta italic" data-id="element-101">
              "Tu cuerpo te habla. Aprendé a escucharlo." 🌸
            </p>
          </div>
        </div>
      </div>
    </section>;
}